import { debounce } from 'lodash'
import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { TChatListData, TUnreadChatRequestData } from 'features/chat/types'
import ChatMessageScreen from 'features/chat/screens/ChatMessageScreen'
import MinimizedChat from './MinimizedChat'

type filterChatListReturn = {
 maxData: TChatListData[]
 minData: TChatListData[]
}

const filterChatList = (
 inputArray: TChatListData[],
 maxEl: number,
): filterChatListReturn => {
 const maxData: TChatListData[] = []
 const minData: TChatListData[] = []

 for (const obj of inputArray) {
  if (!obj.minimized && maxData.length < maxEl) {
   maxData.push(obj)
  } else {
   minData.push(obj)
  }
 }

 return {
  maxData,
  minData,
 }
}

const ChatMessengerWidget: FC<{
 chatList?: TChatListData[]
 chtNotiData?: TUnreadChatRequestData | null
}> = ({ chatList, chtNotiData }) => {
 const [maxEl, setMaxEl] = useState<number>(4)

 const elementParentRef = useRef<HTMLDivElement>(null)

 useEffect(() => {
  const updateResize = () => {
   if (elementParentRef.current) {
    const windowSize = window.innerWidth - 80
    const elWidth = 400
    const maxItem = Math.round(windowSize / elWidth)
    setMaxEl(maxItem)
   }
  }

  const debouncedResize = debounce(updateResize, 200)

  updateResize() // Initial call
  window.addEventListener('resize', debouncedResize)

  return () => {
   window.removeEventListener('resize', debouncedResize)
   debouncedResize.cancel()
  }
 }, [])

 const { maxmizedData, minimizedData } = useMemo(() => {
  if (!chatList) return { maxmizedData: [], minimizedData: [] }
  const { maxData, minData } = filterChatList(chatList, maxEl)
  return { maxmizedData: maxData, minimizedData: minData }
 }, [chatList, maxEl])

 return (
  <div className="chat-messenger-widget">
   <div ref={elementParentRef} className="chat-messenger-list">
    {maxmizedData.map((item, i) => (
     <ChatMessageScreen data={item} key={i} />
    ))}

    <MinimizedChat chtNotiData={chtNotiData} data={minimizedData} />
   </div>
  </div>
 )
}

export default ChatMessengerWidget
